<template>
  <div id="home">
    <OHomeIntro />

    <MSectionUsp />

    <SfSection :title-heading="$t('Unsere Bodenauswahl')" class="section section-carousel-categories container-xl">
      <lazy-hydrate :trigger-hydration="!loading">
        <m-category-carousel
          :categories-ids="[4,6,5,8,69]"
          :show-ad="true"
        />
      </lazy-hydrate>
    </SfSection>

    <SfSection :title-heading="$t('Aus unserer Werbung')" class="section section-carousel-offers container-xl">
      <lazy-hydrate :trigger-hydration="!loading">
        <m-product-carousel :products="newCollection" />
      </lazy-hydrate>
    </SfSection>

    <MSectionStore />

    <SfBannerGrid :banner-grid="1" class="o-banner-grid container-xl">
      <template v-for="(banner, i) in banners" #[banner.slot]>
        <router-link :key="i" :to="banner.link">
          <SfBanner
            :description="banner.description"
            :button-text="banner.buttonText"
            :image="banner.image"
            :class="banner.className"
          >
            <template v-slot:subtitle>
              <div v-if="banner.subtitle" class="sf-banner__subtitle">
                {{ banner.subtitle }}
              </div>
            </template>
            <template v-slot:title>
              <div v-if="banner.title" class="sf-banner__title">
                {{ banner.title }}
              </div>
            </template>
          </SfBanner>
        </router-link>
      </template>
    </SfBannerGrid>

    <SfSection :title-heading="$t('Zubehör für Böden')" class="section section-carousel-categories container-xl">
      <lazy-hydrate :trigger-hydration="!loading">
        <m-category-carousel
          :show-ad="true"
        />
      </lazy-hydrate>
    </SfSection>

    <MSectionUsp />

    <MSectionNewsletter />

    <MSectionSEO />

    <!--
    <ONewsletter />
    -->

    <!--
    <SfSection
      v-if="isOnline"
      :title-heading="$t('Share Your Look')"
      subtitle-heading="#YOURLOOK"
      class="section"
    >
      <AImagesGrid :images="instagramImages" />
    </SfSection>
    -->
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import LazyHydrate from 'vue-lazy-hydration';
import { Logger } from '@vue-storefront/core/lib/logger';
import { isServer, onlineHelper } from '@vue-storefront/core/helpers';
import MProductCarousel from 'theme/components/molecules/m-product-carousel';
import MCategoryCarousel from 'theme/components/molecules/m-category-carousel';
import ONewsletter from 'theme/components/organisms/o-newsletter';
import AImagesGrid from 'theme/components/atoms/a-images-grid';
import { checkWebpSupport } from 'theme/helpers';
import OHomeIntro from 'theme/components/organisms/o-home-intro';
import MSectionUsp from 'theme/components/molecules/m-section-usp';
import MSectionStore from 'theme/components/molecules/m-section-store';
import MSectionSEO from 'theme/components/molecules/m-section-seo';
import MSectionNewsletter from 'theme/components/molecules/m-section-newsletter';
import { ModalList } from 'theme/store/ui/modals'
import EventBus from '@vue-storefront/core/compatibility/plugins/event-bus'

import {
  SfHero,
  SfSection,
  SfBanner
} from '@storefront-ui/vue';
import SfBannerGrid from 'theme/components/organisms/o-banner-grid';

export default {
  name: 'Home',
  components: {
    LazyHydrate,
    SfHero,
    SfSection,
    SfBannerGrid,
    SfBanner,
    MProductCarousel,
    MCategoryCarousel,
    ONewsletter,
    AImagesGrid,
    OHomeIntro,
    MSectionUsp,
    MSectionStore,
    MSectionSEO,
    MSectionNewsletter
  },
  data () {
    return {
      loading: true,
      loadNewsletterPopup: false
    };
  },
  computed: {
    ...mapState({
      isWebpSupported: false /*state => state.ui.isWebpSupported*/
    }),
    ...mapGetters({
      isLoggedIn: 'user/isLoggedIn',
      heroImages: 'promoted/getHeadImage',
      promotedOffers: 'promoted/getPromotedOffers',
      newCollection: 'homepage/getEverythingNewCollection',
      dummyInstagramImages: 'instagram/getInstagramImages'
    }),
    isOnline () {
      return onlineHelper.isOnline;
    },
    banners () {
      return checkWebpSupport(this.promotedOffers.mainBanners, this.isWebpSupported)
    },
    heroes () {
      return checkWebpSupport(this.heroImages, this.isWebpSupported)
    },
    instagramImages () {
      return checkWebpSupport(this.dummyInstagramImages, this.isWebpSupported)
    }
  },
  watch: {
    isLoggedIn () {
      const redirectObj = localStorage.getItem('redirect');
      if (redirectObj) this.$router.push(redirectObj);
      localStorage.removeItem('redirect');
    }
  },
  async asyncData ({ store, context }) {
    Logger.info('Calling asyncData in Home (theme)')();
    if (context) context.output.cacheTags.add(`home`)

    await Promise.all([
      store.dispatch('homepage/fetchNewCollection'),
      store.dispatch('promoted/updateHeadImage'),
      store.dispatch('instagram/updateInstagramImages'),
      store.dispatch('bannerslider/list', {})
    ]);
  },
  mounted () {
    EventBus.$on('session-after-started', () => {
      if (!this.isLoggedIn && localStorage.getItem('redirect')) { this.$bus.$emit('modal-show', 'modal-signup'); }

      if (window?.location?.pathname.match(/^\/customer\/account\//)) {
        if (this.isLoggedIn) {
          this.$router.push(this.localizedRoute('/my-account'))
        } else {
          this.$store.commit('ui/setAuthElem', 'forgot-pass')
          this.openModal({ name: ModalList.Auth, payload: 'login' })
        }
      }
    });
    if (window?.location?.pathname.match(/^\/cart/)) {
      this.openMicrocart()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (!isServer && !from.name) {
      next(vm => {
        vm.$store.dispatch('homepage/fetchNewCollection').then(() => {
          vm.loading = false;
        });
      });
    } else {
      next();
    }
  },
  metaInfo () {
    return {
      title: this.$route.meta.title || this.$i18n.t('Home Page'),
      meta: this.$route.meta.description ? [{ vmid: 'description', name: 'description', content: this.$route.meta.description }] : []
    }
  },
  methods: {
    ...mapActions('ui', {
      openModal: 'openModal'
    }),
  }
};
</script>

<style lang="scss" scoped>
@import "~@storefront-ui/shared/styles/helpers/breakpoints";
#home {
  box-sizing: border-box;
}

.banner-grid {
  margin: var(--spacer-base) 0;
  @include for-desktop {
    margin: var(--spacer-2xl) 0;
  }
}
</style>
